import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'María Elena',
  age: 34,
  role: 'Profesora de música primaria',
  location: 'México',
  text: 'Antes pasaba horas buscando actividades en internet que al final no conectaban entre sí. Con este sistema, tengo todo el año resuelto. Mis alumnos están más enganchados y yo disfruto más dar clases.'
}, {
  name: 'Carlos Andrés',
  age: 41,
  role: 'Docente de música secundaria',
  location: 'Colombia',
  text: 'La estructura de las evaluaciones fue lo que más me impactó. Por fin tengo rúbricas claras y no siento que estoy poniendo notas al azar. Es una herramienta profesional indispensable.'
}, {
  name: 'Luciana',
  age: 29,
  role: 'Maestra de música',
  location: 'Argentina',
  text: 'Increíble la cantidad de material listo para imprimir. Los juegos de emergencia me han salvado en esos días donde el grupo está disperso. Vale cada centavo por la paz mental que te da.'
}, {
  name: 'Roberto',
  age: 38,
  role: 'Profesor de educación musical',
  location: 'Perú',
  text: 'Llevo 10 años enseñando y nunca había visto un material tan bien organizado. No es solo contenido, es una metodología que funciona. Mis clases ahora tienen un hilo conductor real.'
}, {
  name: 'Ana Sofía',
  age: 32,
  role: 'Docente de artes',
  location: 'Chile',
  text: 'Me sentía muy desordenada y eso se notaba en el aula. Desde que uso Música Escolar Lista, entro al salón con seguridad sabiendo exactamente qué hacer. ¡Gracias por crear esto!'
}];
export function Testimonials() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
      {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100 relative hover:shadow-lg transition-shadow duration-300" data-id="element-185">
          <Quote className="absolute top-4 right-4 w-8 h-8 text-amber-200 opacity-50" data-id="element-186" />
          <div className="flex gap-1 mb-4" data-id="element-187">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-188" />)}
          </div>
          <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-189">
            "{t.text}"
          </p>
          <div className="flex items-center gap-3 border-t border-gray-100 pt-4" data-id="element-190">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold text-lg" data-id="element-191">
              {t.name.charAt(0)}
            </div>
            <div data-id="element-192">
              <p className="font-bold text-gray-900 text-sm" data-id="element-193">
                {t.name}, {t.age}
              </p>
              <p className="text-xs text-gray-500" data-id="element-194">
                {t.role} • {t.location}
              </p>
            </div>
          </div>
        </div>)}
    </div>;
}